import $ from 'jquery';

/**
 * Allows selecting a country and region.
 * Dynamically changes visibility of region select fields.
 *
 * Usage:
 *   new Regions(element, onShow);
 *
 * element -> a jQuery object
 * onShow  -> optional callback function run when regions are shown
 */
export default class Regions {
	constructor(element, onShow) {
		this.element = element instanceof $ ? element : $(element);
		this.onShow = onShow;

		this.countrySelect = this.element.find('.select-country');
		this.stateInput = $('.form-group-state');

		this.countrySelect.on('change', this.changeCountry);

		this.changeCountry();
	}

	changeCountry() {
		const country = this.countrySelect.val();
		const regions = $('.regions');
		const matchingRegions = $(`.regions-${country}`);

		regions.addClass('hidden').find('select').prop('disabled', true);

		if (matchingRegions.length) {
			this.stateInput.addClass('hidden');
			matchingRegions.removeClass('hidden').find('select').prop('disabled', false);

			if (typeof this.onShow === 'function') {
				this.onShow(matchingRegions);
			}
		} else {
			this.stateInput.removeClass('hidden');
		}
	}

	off() {
		this.countrySelect.off('change', this.changeCountry);
	}
}
